import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function TransporteAnexo21y22RMF2026SistemasDeMedicionComplementario() {
  return (
    <CategoryPage
      category="transporteAnexo21Y22Rmf2026SistemasDeMedicion2026DocumentosComplementarios"
      pageTitle="Sistemas De Medicion 2026 Documentos Complementarios"
    />
  );
}

export default TransporteAnexo21y22RMF2026SistemasDeMedicionComplementario;
